export const postHeight = {
  mounted() {
    parent.postMessage({ msg: 'Sis height updated', content: document.body.offsetHeight }, '*');
  },
};

export const streamMethods = {
  methods: {
    async updateStream(carouselItem) {
      if (carouselItem.video_src === undefined) {
        try {
          await this.$store.dispatch('getStream', {
            os: this.$browser.os,
            streamData: carouselItem,
          });
        } catch (e) {
          if (!e.response) {
            this.$store.commit('display/setStreamError', {
              statusCode: 520,
              message: this.$t('unknownError'),
              subMessage: this.$t('reloadToTryAgain'),
              hide: false,
            });
          } else {
            this.$store.commit('display/setStreamError', {
              statusCode: 404,
              message: this.$t('unknownError'),
              hide: false,
            });
          }
        }
      } else {
        this.$store.commit('setStream', carouselItem);
      }
    },
  },
};

export const postIssue = {
  methods: {
    postIframeIssue(issue) {
      if (!this.$store.state.display.diagnostics.stream) return;
      const iframeIssue = {
        iframe: this.$store.state.display.diagnostics.stream,
        status: 'open',
        issue,
        retailerUrl: this.$store.state.display.diagnostics.retailerUrl
          ? this.$store.state.display.diagnostics.retailerUrl
          : this.$store.state.display.diagnostics.retailerDomain,
      };
      this.$store.dispatch('postDiagnosticIssue', iframeIssue);
    },
  },
};

export default {
  postHeight,
};
